import React from "react";
import { Box, Typography } from "@mui/material";
import LocationForm, { availableSportsLabels } from "./LocationForm";
import FinalStep from "./FinalStep";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { startLoader, finishLoader } from "../../../../features/user/userSlice";
import { useEffect, useMemo } from "react";
import axiosInstance from "../../../../common/helpers/axios.instance";

export default function CreateLocationField() {
  const complexId = useSelector((state) => state.user.user.complexId);
  const [location, setLocation] = useState({ priceRanges: [] });
  const [complexData, setComplexData] = useState({});
  const [requestState, setRequestState] = useState({});

  // Calculate available availableSportsLabels based on selected sports
  const selectedFields = useMemo(() => ({
    Tenis: complexData?.sports?.Tenis,
    Volejboll: complexData?.sports?.Volejboll,
    Basketboll: complexData?.sports?.Basketboll,
    Futboll: complexData?.sports?.Futboll,
    Padel: complexData?.sports?.Padel
  }), [complexData?.sports]);

  const availableSports = useMemo(() => 
    availableSportsLabels.filter(sport => selectedFields[sport.label] == true),
    [selectedFields]
  );

  useEffect(() => {
    if (complexId) {
        fetchComplexData();
    }
  }, []);

  useEffect(() => {
    console.log("selectedFields", selectedFields);
    console.log("availableSports", availableSports);
    console.log("location", location);
  }, [selectedFields, availableSports, location]);

  const fetchComplexData = async () => {
    if (complexId) {
      try {
        const result = await axiosInstance(process.env.REACT_APP_BASE_API + "/complexes/" + complexId);

        const opensAt = new Date();
        const closesAt = new Date();
        opensAt.setMinutes(0);
        closesAt.setMinutes(0);
         
        setComplexData({
          sports: result.data.data.complex?.[0]?.sports,
          opensAt: opensAt.setHours(+result.data.data.complex?.[0]?.workingHours.from),
          closesAt: closesAt.setHours(+result.data.data.complex?.[0]?.workingHours.to)
        });

      } catch (error) {
        console.log(error);
        alert("Ndodhi nje gabim!");
      }
    }
  };

  
  const handleFieldChange = (fieldName, value) => {
    setLocation((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  // Handler for field type changes
  const handleFieldTypeChange = (value) => {

    setLocation((prev) => ({
      ...prev,
      isFootball: value === "isFootball",
      isBasketball: value === "isBasketball",
      isTennis: value === "isTennis",
      isVolleyball: value === "isVolleyball",
      isPadel: value === "isPadel",
    }));
  };


  const handleSlotRangeChange = (value) => {
    setLocation((prev) => ({
      ...prev,
      slotRange: value,
    }));
  };

  // Add new price range
  const handlePriceRangeAdd = () => {
    const currentRanges = location.priceRanges || [];
    const lastRange = currentRanges[currentRanges.length - 1];
    
    // Auto-set start time to the end time of the previous range
    const newRange = {
      startTime: lastRange?.endTime || "",
      endTime: "",
      price: ""
    };
    
    setLocation((prev) => ({
      ...prev,
      priceRanges: [...currentRanges, newRange]
    }));
  };

  // Remove price range
  const handlePriceRangeRemove = (index) => {
    setLocation((prev) => ({
      ...prev,
      priceRanges: prev.priceRanges.filter((_, i) => i !== index)
    }));
  };

  // Update price range field
  const handlePriceRangeChange = (index, field, value) => {
    setLocation((prev) => {
      const newPriceRanges = [...prev.priceRanges];
      newPriceRanges[index] = {
        ...newPriceRanges[index],
        [field]: value
      };
      return {
        ...prev,
        priceRanges: newPriceRanges
      };
    });
  };

  const handleSubmit = async () => {
      console.log("Location to submit:", JSON.stringify(location));

      const hasSport = location.isFootball || location.isBasketball || 
                      location.isTennis || location.isVolleyball || 
                      location.isPadel;
      
      if (!hasSport) {
        alert("Fushat duhet te kene te perzgjedhur llojin e fushes");
        setRequestState((s) => ({ ...s, isLoading: false }));
        return;
      }

      if (!location.slotRange) {
        alert("Fushat duhet te kene te perzgjedhur kohezgjatjen e seancës");
        setRequestState((s) => ({ ...s, isLoading: false }));
        return;
      }

      // Validate price ranges
      if (!location.priceRanges || location.priceRanges.length === 0) {
        alert("Ju lutem shtoni të paktën një segment kohor me çmim");
        return;
      }

      // Check if all price ranges are complete
      const invalidRange = location.priceRanges.find(range => 
        !range.startTime || !range.endTime || !range.price || parseFloat(range.price) <= 0
      );

      if (invalidRange) {
        alert("Ju lutem plotësoni të gjitha fushat për çdo segment kohor (ora fillimit, ora mbarimit dhe çmimi)");
        return;
      }

      // Check if ranges are continuous (each range starts where the previous one ended)
      for (let i = 1; i < location.priceRanges.length; i++) {
        const prevRange = location.priceRanges[i - 1];
        const currentRange = location.priceRanges[i];
        
        if (prevRange.endTime !== currentRange.startTime) {
          alert(`Segmentet kohore duhet të jenë të vazhdueshme. Segmenti ${i + 1} duhet të fillojë nga ${prevRange.endTime}`);
          return;
        }
      }

      // Check if start time is before end time for each range
      for (let i = 0; i < location.priceRanges.length; i++) {
        const range = location.priceRanges[i];
        const startHour = parseInt(range.startTime.split(':')[0]);
        const endHour = parseInt(range.endTime.split(':')[0]);
        
        if (startHour >= endHour) {
          alert(`Në segmentin ${i + 1}, ora e fillimit duhet të jetë para orës së mbarimit`);
          return;
        }
      }

      setRequestState((s) => ({ ...s, isLoading: true }));

      await axiosInstance
        .post(process.env.REACT_APP_BASE_API + `/complexes/${complexId}/location`,
        location).then((result) => {
          setRequestState((s) => ({ ...s, isLoading: false, isSuccess: true }));
          setLocation({ priceRanges: [] });

        }).catch((error) => {
          console.log("error", error);
          setRequestState((s) => ({ ...s, isLoading: false, isError: true }));
        }).finally(() => {
          setTimeout(() => {
            setRequestState((s) => ({ ...s, isLoading: false, isSuccess: false, isError: false }));
          }, 3000);
        });
  };

  return (
    <Box m={2} backgroundColor="white" borderRadius={2} padding={2}>
      <Typography variant="h6">Shtoni nje fushe te re per Kompleksin tuaj</Typography>

      <LocationForm 
        location={location}
        availableSports={availableSports}
        complexData={complexData}
        onFieldChange={handleFieldChange}
        onFieldTypeChange={handleFieldTypeChange}
        onSlotRangeChange={handleSlotRangeChange}
        onPriceRangeAdd={handlePriceRangeAdd}
        onPriceRangeRemove={handlePriceRangeRemove}
        onPriceRangeChange={handlePriceRangeChange}
      />
      <FinalStep handleSubmit={handleSubmit} requestState={requestState} />
    </Box>
  );
}
